// @ts-strict
import { Injectable } from '@angular/core';
import { SohoBusyIndicatorDirective, } from 'ids-enterprise-ng';
import { AppComponent } from '@app/app.component';

@Injectable()
export class LMBusyIndicatorService {
  private m_appComponent!: AppComponent;

  public set appComponent(appComponent: AppComponent) {
    this.m_appComponent = appComponent;
  }

  public showBusyIndicator(sohoBusyIndicator?: SohoBusyIndicatorDirective): void {
    if (this.isGlobalBusyIndicatorOpen()) {
      return;
    }

    if (!sohoBusyIndicator) {
      this.m_appComponent.sohoBusyIndicator.open();
    } else if (!sohoBusyIndicator.isActive()){
      sohoBusyIndicator.open();
    }
  }

  public hideBusyIndicator(sohoBusyIndicator?: SohoBusyIndicatorDirective): void {

    if (this.isGlobalBusyIndicatorOpen()) {
      this.m_appComponent.sohoBusyIndicator.close(false);
    }

    if (sohoBusyIndicator?.isActive()) {
      sohoBusyIndicator.close(false);
    }
  }

  private isGlobalBusyIndicatorOpen(): boolean | undefined {
    return this.m_appComponent.sohoBusyIndicator.isActive();
  }
}
